import React, { Component } from 'react';




export default class InquiryModal extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        if (this.props.mystate.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="modal-dialog friendly-calls-modal" role="document">
                        <div class="modal-content">
                            <div className='contact-modal'>
                            <h5>Thank you for getting in touch!</h5>
                            <p>We have received your inquiry and would like to thank you for showing your interest. If your inquiry is urgent, please use the telephone number listed below to talk to one of our staff members.</p>
                            <p>Otherwise, we will reply by email as soon as possible.</p>
                            <p>Talk to you soon <span>Kinship Living</span></p>
                            <button  type='button' className='btn' onClick={()=>this.props.CloseModal()}>Get back to Tour List </button>
                            </div>

                           
                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}